import { render } from "./index.vue?vue&type=template&id=6940bc9b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6940bc9b&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6940bc9b"],['__file',"src/views/DashboardGestor/components/DashboardGestorModalRelatorio/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6940bc9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6940bc9b', __exports__)) {
    console.log('reload')
    api.reload('6940bc9b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6940bc9b&scoped=true", () => {
    console.log('re-render')
    api.rerender('6940bc9b', render)
  })

}


export default __exports__